"use client";

import { Icon } from "@pamperedchef/design-system";
import { RichText } from "@/composites/foundation";
import type { BlockOf } from "@/domain/catalog";
import * as styles from "./FeatureHighlight.module.scss";

/**
 * Adapter for the `feature_highlight_block` modular block.
 *
 * Per `docs/PDP_ARCHITECTURE.md` ("Content blocks"), this
 * file is a thin shell over UI: it unpacks the typed CMS payload and
 * forwards display props.
 */
export function FeatureHighlight({
	block
}: {
	block: BlockOf<"feature_highlight_block">;
}) {
	return (
		<section
			className={styles["feature-highlight"]}
			data-block="feature_highlight_block"
		>
			<h2 className={styles["feature-highlight__headline"]}>
				{block.headline}
			</h2>

			{block.body ? (
				<div className={styles["feature-highlight__body"]}>
					<RichText content={block.body} />
				</div>
			) : null}

			{block.chips && block.chips.length > 0 ? (
				<ul
					className={styles["feature-highlight__chips"]}
					aria-label="Feature highlights"
				>
					{block.chips.map((chip, i) => (
						<li
							key={`${chip.label}-${i}`}
							className={styles["feature-highlight__chip"]}
						>
							{chip.icon ? (
								<span
									className={
										styles["feature-highlight__chip-icon"]
									}
								>
									<Icon
										name={chip.icon}
										width={22}
										height={22}
									/>
								</span>
							) : null}
							<span>{chip.label}</span>
						</li>
					))}
				</ul>
			) : null}
		</section>
	);
}
